export default {
	messages: {
		required: (field) => `Este campo es requerido`,
		numeric: (field) => `Este campo es de tipo número`,
		length: (field) => `El campo está mal formado`,
		checkcentrocoste : () => `El campo tiene una estructura erronea`,
		checkordeninterna : () => `El campo tiene una estructura erronea`
	},
	custom: {

		email: {
			required: 'El campo email es obligatorio',
			email: 'Debes indicar una dirección de correo electrónico válida'
		},
		telefono: {
			required: 'El campo teléfono es obligatorio',
			length: 'El campo teléfono está mal formado',
			min: 'El campo teléfono está mal formado',
			decimal: 'El campo teléfono es obligatorio'
		},
		nombre: {
			required: 'El campo nombre es obligatorio'
		},
		inicio: {
			required: 'Requerido'
		},
		fin: {
			required: 'Requerido',
			after: 'La fecha de fin debe ser mayor a la fecha de inicio'	
		},
		mensaje: {
			required: 'El campo mensaje es obligatorio'
		},
		apellidos: {
			required: 'El campo apellidos es obligatorio'
		},
		politica: {
			required: 'Debes aceptar la política de privacidad'
		},
		direccion: {
			required: 'El campo direccion es obligatorio'
		},
		pais: {
			required: 'El campo pais es obligatorio'
		},
		carta_presentacion: {
			required: 'El campo carta de presentación es obligatorio'
		},
		tratamientodedatos: {
			required: 'Este campo es obligatorio'
		},
		comunicaciones: {
			required: 'Este campo es obligatorio'
		},
		doc_adjunto: {
			size: 'El tamaño maximo son 2MB',
			mimes: 'El formato debe ser PDF'
		},
		file: {
			size: 'El tamaño maximo son 2MB',
			mimes: 'El formato no está permitido'
		},
		titulooferta: {
			required: 'El campo es requerido'
		},
		numeropuestos: {
			required: 'El campo es requerido'
		},
		tipocontrato: {
			required: 'El campo es requerido'
		},
		remuneracion: {
			required: 'El campo es requerido'
		},
		funciones: {
			required: 'El campo es requerido'
		},
		keywords: {
			required: 'El campo es requerido'
		},
		direccion: {
			required: 'El campo es requerido'
		},
		pais: {
			required: 'El campo es requerido'
		},
		provincia: {
			required: 'El campo es requerido'
		},
		adjunto: {
			required: 'El campo es requerido'
		},
		poblacion: {
			required: 'El campo es requerido'
		},
		numeropuestos: {
			required: 'El campo es requerido'
		},
		nombrefiscal: {
			required: 'El campo es requerido'
		},
		nombrecomercial: {
			required: 'El campo es requerido'
		},
		cif: {
			required: 'El campo es requerido'
		},
		tipoempresa: {
			required: 'El campo es requerido'
		},
		sectoractividad: {
			required: 'El campo es requerido'
		},
		descripcion: {
			required: 'El campo es requerido'
		},
		codigopostal: {
			required: 'El campo es requerido'
		},
		puesto: {
			required: 'El campo es requerido'
		},
		usuariologin: {
			required: 'El campo es requerido'
		},
		contrasena: {
			required: 'El campo es requerido',
			min: "La contraseña debe contener 8 caractéres",
		},
		contrasena_2: {
			required: 'El campo es requerido',
			min: "La contraseña debe contener 8 caractéres",
			confirmed: "Las contraseñas no coinciden"
		},
		twitter: {
			url: 'La url está mal formada'
		},
		facebook: {
			url: 'La url está mal formada'
		},
		linkedin: {
			url: 'La url está mal formada'
		},
		sexo: {
			required: 'El campo sexo es obligatorio'
		},
		estado: {
			required: 'No puedes dejar el estado vacio'
		},
		numeropuestos: {
			required: 'El campo es requerido'
		},
		horasDia: {
			required: 'El campo es requerido',
			numeric: 'El campo es requerido',
			length: 'El campo es requerido'
		},
		iban: {
			length: 'Su longitud minima son 24 carácteres'
		},
	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js